<ng-template #myStatusGroups>
  <div class="flex items-center gap-4">
    <h5>Deine eigenen Business Units</h5>
    @for (statusgroup of myStatusGroupLabels; track statusgroup) {
      <div class="badge badge-xs badge-secondary whitespace-nowrap">
        {{ statusgroup }}
      </div>
    }
  </div>
  <hr class="my-2 bg-neutral" />
</ng-template>
@if (isOpen()) {
  <if-multiselect
    [optionGroups]="allStatusGroups"
    [selectedOptions]="selectedVisibilityGroups"
    [disabledPreselectedOptions]="disabledPreselectedGroups"
    (selectedOptionsChange)="selectChange.emit($event)"
    [footnote]="consultantInfo"
    [showSelectAll]="showSelectAll()"
  />
}
<ng-template #consultantInfo>
  @if (isConsultant) {
    <div>
      <div class="w-full h-px bg-grey-400 my-4"></div>
      <div class="text-sm">Als Consultant werden die Erfahrungslevel mit dem Management immer geteilt.</div>
    </div>
  }
</ng-template>
